import React, { useState } from 'react';
import { productReportsService } from '../../services/productReportsService';

const SoldSearchReport = ({ locationId }) => {
  const [soldProductsSearch, setSoldProductsSearch] = useState(null);
  const [soldSearchLoading, setSoldSearchLoading] = useState(false);
  const [error, setError] = useState(null);
  const [soldSearchParams, setSoldSearchParams] = useState({
    search: '',
    date_from: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    date_to: new Date().toISOString().split('T')[0],
    use_days: false,
    days: 30
  });

  const searchSoldProducts = async () => {
    if (!soldSearchParams.search || soldSearchParams.search.length < 2) {
      setError('Wprowadź minimum 2 znaki do wyszukiwania');
      return;
    }

    try {
      setSoldSearchLoading(true);
      setError(null);
      const params = {
        search: soldSearchParams.search,
        location_id: locationId
      };

      if (soldSearchParams.use_days) {
        params.days = soldSearchParams.days;
      } else {
        params.date_from = soldSearchParams.date_from;
        params.date_to = soldSearchParams.date_to;
      }

      const response = await productReportsService.getSoldProductsSearch(params);
      setSoldProductsSearch(response.data || null);
    } catch (err) {
      console.error('Blad wyszukiwania sprzedanych produktow:', err);
      setError('Blad wyszukiwania: ' + err.message);
    } finally {
      setSoldSearchLoading(false);
    }
  };

  return (
    <div>
      {error && (
        <div style={{
          padding: '0.5rem 0.75rem',
          marginBottom: '0.5rem',
          backgroundColor: 'var(--danger-light)',
          border: '1px solid var(--danger-light)',
          borderRadius: '4px',
          color: 'var(--danger)',
          fontSize: '0.75rem'
        }}>
          {error}
          <button
            onClick={() => setError(null)}
            style={{ float: 'right', background: 'none', color: 'var(--danger)' }}
          >x</button>
        </div>
      )}
      <div style={{ border: '1px solid var(--border)', borderRadius: '0.375rem', backgroundColor: 'var(--card-bg)' }}>
        <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
          <h5 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>🔍 Wyszukaj sprzedane produkty</h5>
        </div>
        <div style={{ padding: '0.75rem' }}>
          {/* Formularz wyszukiwania */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '0.5rem', marginBottom: '0.75rem' }}>
            <div>
              <input
                type="text"
                placeholder="Wpisz nazwę, kod lub EAN produktu..."
                style={{
                  width: '100%',
                  padding: '6px 10px',
                  fontSize: '12px',
                  border: '1px solid var(--border)',
                  borderRadius: '6px',
                  backgroundColor: 'var(--card-bg)',
                  color: 'var(--text)'
                }}
                value={soldSearchParams.search}
                onChange={(e) => setSoldSearchParams({...soldSearchParams, search: e.target.value})}
                onKeyPress={(e) => e.key === 'Enter' && searchSoldProducts()}
              />
            </div>
            <button
              onClick={searchSoldProducts}
              disabled={soldSearchLoading}
              style={{
                padding: '6px 12px',
                border: '1px solid var(--primary)', color: 'var(--primary)' ,
                fontSize: '12px',
                fontWeight: '500'
              }}
            >
              {soldSearchLoading ? 'Szukam...' : '🔍 Szukaj'}
            </button>
          </div>

          {/* Wybor zakresu dat */}
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '11px', color: 'var(--text-muted)' }}>
              <input
                type="radio"
                checked={!soldSearchParams.use_days}
                onChange={() => setSoldSearchParams({...soldSearchParams, use_days: false})}
              />
              Zakres dat
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '11px', color: 'var(--text-muted)' }}>
              <input
                type="radio"
                checked={soldSearchParams.use_days}
                onChange={() => setSoldSearchParams({...soldSearchParams, use_days: true})}
              />
              Ostatnie dni
            </label>

            {!soldSearchParams.use_days ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                  <label style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Od:</label>
                  <input
                    type="date"
                    style={{ padding: '6px 10px', fontSize: '12px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
                    value={soldSearchParams.date_from}
                    onChange={(e) => setSoldSearchParams({...soldSearchParams, date_from: e.target.value})}
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                  <label style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Do:</label>
                  <input
                    type="date"
                    style={{ padding: '6px 10px', fontSize: '12px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
                    value={soldSearchParams.date_to}
                    onChange={(e) => setSoldSearchParams({...soldSearchParams, date_to: e.target.value})}
                  />
                </div>
              </>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                <label style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Dni:</label>
                <input
                  type="number"
                  style={{ width: '70px', padding: '6px 10px', fontSize: '12px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
                  value={soldSearchParams.days}
                  onChange={(e) => setSoldSearchParams({...soldSearchParams, days: parseInt(e.target.value) || 30})}
                  min="1"
                  max="365"
                />
              </div>
            )}
          </div>

          {/* Wyniki wyszukiwania */}
          {soldProductsSearch && (
            <div>
              {/* Podsumowanie */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '0.5rem',
                marginBottom: '0.75rem',
                padding: '0.5rem',
                backgroundColor: 'var(--bg)',
                borderRadius: '4px'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--primary)' }}>
                    {soldProductsSearch.total_products_found}
                  </div>
                  <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Znalezionych produktów</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--success)' }}>
                    {parseFloat(soldProductsSearch.total_quantity_sold || 0).toFixed(0)}
                  </div>
                  <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Sprzedanych sztuk</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--info)' }}>
                    {parseFloat(soldProductsSearch.total_revenue || 0).toFixed(2)} zł
                  </div>
                  <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Łączny przychód</div>
                </div>
              </div>

              {/* Tabela produktów */}
              {soldProductsSearch.products && soldProductsSearch.products.length > 0 ? (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.75rem' }}>
                    <thead>
                      <tr style={{ backgroundColor: 'var(--bg)' }}>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left' }}>Nazwa produktu</th>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left' }}>Kod</th>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left' }}>EAN</th>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'left' }}>Kategoria</th>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>Sprzedano szt.</th>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>Transakcji</th>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>Przychód</th>
                        <th style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>Śr. cena</th>
                      </tr>
                    </thead>
                    <tbody>
                      {soldProductsSearch.products.map((product, index) => (
                        <tr key={product.id} style={{ backgroundColor: index % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)' }}>
                          <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)' }}>
                            <span style={{ fontWeight: '500' }}>{product.nazwa}</span>
                          </td>
                          <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', color: 'var(--text-muted)' }}>
                            {product.kod_produktu || '-'}
                          </td>
                          <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', color: 'var(--text-muted)' }}>
                            {product.ean || '-'}
                          </td>
                          <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)' }}>
                            {product.kategoria_nazwa || '-'}
                          </td>
                          <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>
                            <span style={{
                              fontWeight: '600',
                              color: parseFloat(product.total_quantity_sold || 0) > 0 ? 'var(--success)' : 'var(--danger)'
                            }}>
                              {parseFloat(product.total_quantity_sold || 0).toFixed(0)}
                            </span>
                          </td>
                          <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>
                            {product.transactions_count || 0}
                          </td>
                          <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'right', fontWeight: '500' }}>
                            {parseFloat(product.total_revenue || 0).toFixed(2)} zł
                          </td>
                          <td style={{ padding: '0.4rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>
                            {parseFloat(product.avg_price || product.cena || 0).toFixed(2)} zł
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '1rem', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                  Brak produktów pasujących do wyszukiwania
                </div>
              )}
            </div>
          )}

          {!soldProductsSearch && (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
              Wpisz frazę i kliknij "Szukaj" aby znaleźć produkty
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SoldSearchReport;
